var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STYLES",
    transform: "translate(18 13.636) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Components"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_x2F_Social_x2F_insta-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_02-social-media"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.129,0H4.98A5.025,5.025,0,0,0,0,4.981v8.038A5.025,5.025,0,0,0,4.98,18h8.036A5.025,5.025,0,0,0,18,13.019V4.981A4.857,4.857,0,0,0,13.129,0Zm3.282,13.132a3.406,3.406,0,0,1-3.4,3.4H4.98a3.406,3.406,0,0,1-3.4-3.4V4.981a3.406,3.406,0,0,1,3.4-3.4h8.036a3.405,3.405,0,0,1,3.4,3.4v8.151Z",
    transform: "translate(0 -4.364)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    d: "M4.365,0A4.318,4.318,0,0,0,0,4.367,4.318,4.318,0,0,0,4.365,8.734,4.318,4.318,0,0,0,8.73,4.367,4.318,4.318,0,0,0,4.365,0Zm0,7.243A2.876,2.876,0,1,1,7.24,4.367,2.863,2.863,0,0,1,4.365,7.243Z",
    transform: "translate(4.394 0.595)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    d: "M1,0A.908.908,0,0,0,.3.3,1.08,1.08,0,0,0,0,1a.908.908,0,0,0,.3.7A1.08,1.08,0,0,0,1,2a.908.908,0,0,0,.7-.3A1.08,1.08,0,0,0,2,1,.908.908,0,0,0,1.7.3,1.08,1.08,0,0,0,1,0Z",
    transform: "translate(12.068 -0.344)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0eaa5079b7b62c9a27bebec0abc71354.svg";
export { ForwardRef as ReactComponent };